<script lang="ts">
  import CalendarIcon from "lucide-svelte/icons/calendar";
  import {
    type DateValue,
    CalendarDate,
    DateFormatter,
    getLocalTimeZone,
    parseDate,
    parseDateTime,
  } from "@internationalized/date";
  import { cn } from "$lib/utils.js";
  import { Button } from "$lib/components/ui/button";
  import { Calendar } from "$lib/components/ui/calendar";
  import * as Popover from "$lib/components/ui/popover";
  import { t } from "svelte-i18n";
  import { locale } from 'svelte-i18n';
  import { DateTime } from "luxon";
  import { createEventDispatcher } from "svelte";

  $: df = new DateFormatter($locale ?? "fr-FR", {
    dateStyle: "long",
  });

  let dateValue: DateValue | undefined = undefined;
  
  export let value: string | undefined = undefined;
  export let disabled: boolean = false;
  
  const dispatch = createEventDispatcher();

  
  $: convertToDate(value);

  $: convertToString(dateValue);

  function convertToDate(strValue: string | undefined) {
    console.log('converting', strValue);
    if( strValue ) {
      dateValue = toDateValue(strValue);
      
    }
    else  
      dateValue = undefined;
  }

  function toDateValue(dateString: string): DateValue | undefined {
    try {
        // Essayer de parser en tant que Date seulement (ignorer l'heure)
        if (dateString.includes('T')) {
            const dateTime = parseDateTime(dateString);
            return new CalendarDate(dateTime.calendar, dateTime.year, dateTime.month, dateTime.day);
        } else {
            return parseDate(dateString);
        }
    } catch (error) {
        console.error('Erreur lors de la conversion de la chaîne en DateValue:', error);
        return undefined; // Retourne null en cas d'erreur de parsing
    }
}

  function convertToString(dValue: DateValue | undefined) {
    console.log('converting', dValue);
    if( dValue ) {
      value = dValue.toString();
    }
    else  
      value = undefined;

    dispatch('dateSelected', value);
  }
</script>

<Popover.Root openFocus>
  <Popover.Trigger asChild let:builder>
    <Button
      {disabled}
      variant="outline"
      class={cn(
        "w-[145px] justify-start text-left font-normal text-xs",
        !dateValue && "text-muted-foreground"
      )}
      builders={[builder]}
    >
      <!-- <CalendarIcon class="mr-2 h-4 w-4" /> -->
      {dateValue ? df.format(dateValue.toDate(getLocalTimeZone())) : $t('global.messages.select-date')}
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-auto p-0">
    <Calendar bind:value={dateValue} initialFocus />
  </Popover.Content>
</Popover.Root>
